/* eslint-disable import/no-unresolved */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ManagementState } from 'store/modules/management_store/types';
import { ApplicationState } from 'store';
import { getManagementSummary } from 'store/modules/management_store/actions';
import { BiddingState } from 'store/modules/bidding_store/types';
import companyId from 'services/company_id';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import ManagementMenuItem from '../management_menu_item';
import { Container } from './styles';

const ManagementMenu = () => {
  const dispatch = useDispatch();

  const { management } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const { biddings } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    dispatch(getManagementSummary(management.filtered_by, companyId(profile)));
  }, []);

  useEffect(() => {
    dispatch(getManagementSummary(management.filtered_by, companyId(profile)));
  }, [
    biddings.bidding_list,
    management.tasks,
    management.managed,
    management.progress,
    management.notification_progress,
    management.finished,
    profile.currentCompany[tabId()],
  ]);

  return (
    <Container className="col-12 card-group mb-4">
      <ManagementMenuItem
        featureId="calendar"
        featureLabel="Calendário"
        isActive={management.selected_feature === 'calendar'}
      />
      <ManagementMenuItem
        featureId="favorites"
        featureLabel="Licitações favoritadas"
        isActive={management.selected_feature === 'favorites'}
      />
      <ManagementMenuItem
        featureId="managed"
        featureLabel="Licitações gerenciadas"
        isActive={management.selected_feature === 'managed'}
      />
      <ManagementMenuItem
        featureId="tasks"
        featureLabel="Tarefas"
        isActive={management.selected_feature === 'tasks'}
      />
      <ManagementMenuItem
        featureId="progress"
        featureLabel="Andamentos"
        isActive={management.selected_feature === 'progress'}
      />
      <ManagementMenuItem
        featureId="finished"
        featureLabel="Licitações finalizadas"
        isActive={management.selected_feature === 'finished'}
      />
    </Container>
  );
};

export default ManagementMenu;
